import React, { useEffect, useState } from "react";
import viewBg from "assets/images/common/others/viewBg.png";
import { ReactComponent as DeleteIconSvg } from "assets/images/common/svgs/delete.svg";
import { ReactComponent as ReviewGolden } from "assets/images/common/svgs/reviewGolden.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { useNavigate } from "react-router-dom";
import Events from "./component/Event";
import Overview from "./component/Overview";
import Subscription from "./component/Subscription";
import { UserDTO } from "utils/helpers/models/users/user.dto";
import useUsers from "containers/user-management/useHooks";
import useUtils from "hooks/useUtils";
import Reviews from "./component/Reviews";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import CupOfGratitude from "./component/CupOfGratitude";

interface Tab {
  name: string;
  Component: JSX.Element;
}

const ViewHost = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>({});

  const tabs: Tab[] = [
    { name: "Overview", Component: <Overview user={user} /> },
    { name: "Events", Component: <Events hostId={user?.user?.id}  /> },
    { name: "Cup of Gratitude", Component: <CupOfGratitude hostId={user?.user?.id}/> },
    { name: "Reviews", Component:   <Reviews hostId={user?.user?.id} /> },
    { name: "Subscription", Component: <Subscription user={user} /> },
  ];

  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const { getUserById } = useUsers();
  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();
  const goToBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getUserById(params?.id, setUser);
  }, []);

  console.log(user);

  return (
    <div>
      <div className="flex justify-between items-center gap-4 ">
        <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {`${user?.user?.firstName} ${user?.user?.lastName}`}’s Profile
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">Block User</p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-redtext">Delete User</p>
            <DeleteIconSvg />
          </span>
        </div> */}
      </div>
      <div className="">
        <div
          style={{ backgroundImage: `url(${viewBg})` }}
          className="bg-cover bg-center bg-no-repeat h-[150px] w-full rounded-lg"
        ></div>
        <div className="flex items-center gap-6 mt-[-65px] px-6">
          <div className="">
            <img
              className="w-[132px] h-[132px] rounded-full border-4 border-white"
              src={
                user?.user?.profilePicUrl
                  ? concatPathWithBackendUrl(
                      user?.user?.profilePicUrl?.fileDownloadUri
                    )
                  : editProfilePicUser
              }
              alt="ProfileUSer"
            />
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-xl font-bold text-white">{`${user?.user?.firstName} ${user?.user?.lastName}`}</span>
            <span className="flex gap-2 items-center">
              <ReviewGolden />
              <p className="text-primaryText text-xs">( {user?.profiles?.host?.avgRating || 0.0} )</p>
            </span>
          </div>
        </div>
      </div>
      <div className="py-4">
        <div className="mt-4 flex gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={` rounded-md px-3 py-2 font-medium text-xs transition-colors duration-300 ${
                activeTab.name === tab.name
                  ? "bg-vibrantBlueBg text-white "
                  : "bg-warmOffWhiteBg text-mediumGrayText"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">
          {activeTab.name === "Overview" ? (
            <Overview user={user} />
          ) : activeTab.name === "Events" ? (
            <Events hostId={user?.user?.id} />
          ) : activeTab.name === "Cup of Gratitude" ? (
            <CupOfGratitude hostId={user?.user?.id}/>
          ) : activeTab.name === "Reviews" ? (
            <Reviews hostId={user?.user?.id} />
          ) : activeTab.name === "Subscription" ? (
            <Subscription user={user} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ViewHost;